import { render, staticRenderFns } from "./SiteMenuItem.vue.js?vue&type=template&id=5135ddda!=!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./SiteMenuItem.vue?vue&type=template&id=5135ddda"
import script from "./SiteMenuItem.vue.js?vue&type=script&lang=js!=!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./SiteMenuItem.vue?vue&type=script&lang=js"
export * from "./SiteMenuItem.vue.js?vue&type=script&lang=js!=!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./SiteMenuItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports